import { Suspense, useEffect, useState } from 'react';
import './App.css';
import { ConfigProvider } from 'antd';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLanguageLocale, locales, defaultLanguage } from './i18n'
import intl from 'react-intl-universal';
import routes from './routes';
import { getLanguage } from './selectors';
import { changeLanguage } from './slices/language';
import { matchMediaChange } from './slices/matchMedia';
import { Locale } from './i18n';

const App: React.FC = () => {
	const dispatch = useDispatch()
	const { language } = useSelector(getLanguage);
	const [locale, setLocale] = useState<Locale>(getLanguageLocale(language));
	
	const matchMediaChanged = (e: MediaQueryListEvent) => {
		dispatch(matchMediaChange(e.matches ? 'mobile' : 'desktop'));
	}

	const setLocaleByLanguage = (lang: string) => {
		let locale = getLanguageLocale(lang);
		dayjs.locale(locale.dayjs);
		intl.init({
			currentLocale: locale.locale,
			locales,
		});
		setLocale(locale);
	}

	useEffect(() => {
		let lang = window.navigator.language;
		if (lang && lang.includes('zh-TW')) {
		  lang = 'zh_TW';
		} else {
			lang = defaultLanguage;
		}
		setLocaleByLanguage(lang)
		dispatch(changeLanguage(lang))

		const mediaQuery = window.matchMedia("(max-width: 900px)");
		dispatch(matchMediaChange(mediaQuery.matches ? 'mobile' : 'desktop'));

		mediaQuery.addEventListener("change", matchMediaChanged);
    
		return () => {
			mediaQuery.removeEventListener("change", matchMediaChanged)
		}

  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	const element = useRoutes(routes);
  return (
		<ConfigProvider locale={locale.antd}>
			<div className='App'>
				<Suspense>{element}</Suspense>
			</div>
    </ConfigProvider>
  );
}

export default App;
